import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react'

export interface SortableHeaderProps {
  label: string
  field: string
  sortField: string
  sortDirection: 'asc' | 'desc'
  onSortChange: (field: string, direction: 'asc' | 'desc') => void
}

/**
 * Clickable table-header button that toggles single-field sorting.
 * Clicking an inactive header sorts ascending; clicking the active header
 * flips direction. Shared across the VoE and Applicants tables.
 */
const SortableHeader = ({
  label,
  field,
  sortField,
  sortDirection,
  onSortChange,
}: SortableHeaderProps) => {
  const isActive = sortField === field
  const nextDirection = isActive && sortDirection === 'asc' ? 'desc' : 'asc'

  return (
    <button
      className="flex items-center gap-1 whitespace-nowrap hover:text-doubleNickel-gray-900"
      onClick={(e) => {
        e.stopPropagation()
        onSortChange(field, nextDirection)
      }}
    >
      {label}
      {isActive ? (
        sortDirection === 'asc' ? (
          <ChevronUp className="h-3 w-3 flex-shrink-0 stroke-doubleNickel-brand-500" />
        ) : (
          <ChevronDown className="h-3 w-3 flex-shrink-0 stroke-doubleNickel-brand-500" />
        )
      ) : (
        <ChevronsUpDown className="h-3 w-3 flex-shrink-0 stroke-doubleNickel-gray-400" />
      )}
    </button>
  )
}

export default SortableHeader
